var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"events-layout events-auth-layout"},[_c('events-header'),_vm._v(" "),_c('div',{staticClass:"position-relative"},[_c('nuxt'),_vm._v(" "),_c('chat')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }